import { render, staticRenderFns } from "./AdvertisesPage.vue?vue&type=template&id=7669708b&scoped=true&"
import script from "./AdvertisesPage.vue?vue&type=script&lang=js&"
export * from "./AdvertisesPage.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisesPage.vue?vue&type=style&index=0&id=7669708b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669708b",
  null
  
)

export default component.exports